import React from 'react';
import './Loader.scss';

/**
 * Route-level loading indicator.
 *
 * `fullScreen` (the default) covers the viewport and is only appropriate
 * while a whole page is loading. Sections that load *inside* an already
 * rendered page must pass `fullScreen={false}` — or better, use a skeleton —
 * otherwise the overlay blanks out the rest of the page.
 */
const Loader = ({ fullScreen = true, label = 'Loading' }) => (
  <div
    className={fullScreen ? 'ij-loader ij-loader--fullscreen' : 'ij-loader'}
    role="status"
    aria-live="polite"
  >
    <span className="ij-loader__ring" aria-hidden="true" />
    <span className="ij-visually-hidden">{label}</span>
  </div>
);

export default Loader;
